import type { SVGProps } from "react";
// generated from Control.svg — do not edit manually
// prettier-ignore
export default function Control(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 14 7 C 14 9.209 15.791 11 18 11 C 20.209 11 22 9.209 22 7 C 22 4.791 20.209 3 18 3 C 15.791 3 14 4.791 14 7 Z M 14 7 H 2 M 10 17 C 10 19.209 8.209 21 6 21 C 3.791 21 2 19.209 2 17 C 2 14.791 3.791 13 6 13 C 8.209 13 10 14.791 10 17 Z M 10 17 H 22" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
